import { render, staticRenderFns } from "./stationed_account_extract_detail.vue?vue&type=template&id=38f99358&scoped=true"
import script from "./stationed_account_extract_detail.vue?vue&type=script&lang=js"
export * from "./stationed_account_extract_detail.vue?vue&type=script&lang=js"
import style0 from "./stationed_account_extract_detail.vue?vue&type=style&index=0&id=38f99358&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f99358",
  null
  
)

export default component.exports